import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { title } from "./Header.module.scss";

const HeaderTitle = ({ className, ...props }) => (
  <h1
    className={classnames(title, className)}
    {...props}
    data-selector="header-title"
  />
);

HeaderTitle.propTypes = {
  className: PropTypes.string
};

export default HeaderTitle;
